import { qualifyUrls } from "routing/Routes";
const DataTieringRoutes = {
  WARM_TIER_REPOSITORIES: "/system/indices/warm_tier_repositories"
};
const routes = qualifyUrls(DataTieringRoutes);
export default {
  ...routes,
  unqualified: DataTieringRoutes
};
